import CableService from 'tio-common/services/cable';

type Callbacks = Parameters<CableService['subscribe']>[1];

const batchIdOf = (params: object) => {
  if (!('channel' in params) || !('batch' in params)) return undefined;
  return params.channel === 'ObservableDocumentBatchStatusChannel' &&
    typeof params.batch === 'string'
    ? params.batch
    : undefined;
};

export default class EmployeeCableService extends CableService {
  #demoBatchCallbacks = new Map<string, Callbacks>();

  override subscribe(params: object, callbacks: Callbacks): ReturnType<CableService['subscribe']> {
    const batchId = this.disabled ? batchIdOf(params) : undefined;
    if (batchId) {
      this.#demoBatchCallbacks.set(batchId, callbacks);
      return undefined;
    }
    return super.subscribe(params, callbacks);
  }

  override unsubscribe(params: object) {
    const batchId = batchIdOf(params);
    if (batchId) this.#demoBatchCallbacks.delete(batchId);
    super.unsubscribe(params);
  }

  emitDemoBatchStatus(batchId: string, message: unknown) {
    if (this.disabled) this.#demoBatchCallbacks.get(batchId)?.received?.(message);
  }
}
